import { useHistory } from 'react-router'
import TemplateItem from './TemplateItem'
import { useEffect, useState } from 'react'
import { ROLES } from '../../../config/user'
import WAIcon from '@material-ui/icons/WhatsApp'
import { ITemplate } from '../../../types/templates'
import { makeStyles } from '@material-ui/core/styles'
import { getTemplates } from '../../../services/templates'
import { useSession } from '../../../context/SessionContext'
import Alert, { ActionsOptType } from '../../../components/Alert'
import { Button, Container, Grid, Typography, useTheme } from '@material-ui/core'

/**
 * define styles for the component
*/
const useStyles = makeStyles((theme) => ({
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  addTemplate: {
    maxWidth: '60vw',
    marginBottom: '2vh',
  },
}))

/**
 * Custom `TemplateList` component declaration.
 * This component is used to show the templates created and the functionalities for the adminPanel
 * @return TemplateList
*/
const TemplateList = ({
  // setTemplate,
  copyWelcome,
}: {
  // setTemplate: (newState: any) => void
  copyWelcome: string
}): JSX.Element => {
  const classes = useStyles()
  const history = useHistory()
  const theme = useTheme()
  const { user } = useSession()
  const [templates, setTemplates] = useState<ITemplate[] | null>()
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })

  // load templates
  useEffect(() => {
    const fetchData = async () => {
      const { data, error } = await getTemplates()
      if (data) setTemplates(data)
      if (error) setAlertOptions({ message: error, open: true, type: 'error' })
    }
    if (!templates) {
      fetchData()
    }
  }, [])
  
  return (
    <>
      <Container className={classes.cardGrid} maxWidth="md">
        <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />
        <Typography
          component="p"
          variant="body1"
          align="center"
          color="textPrimary"
          gutterBottom
          style={{ fontSize: '2rem', fontWeight: 'bold' }}
        >
          ¡Te damos la bienvenida a Justiexpress!
        </Typography>
        {user?.role === ROLES.ADMIN && (
          <Button
            onClick={() => history.push({ pathname: '/docengine/editor' })}
            variant="contained"
            color="primary"
            className={classes.addTemplate}
          >
            Crear plantilla
          </Button>
        )}
        <Typography
          variant="body1"
          align="justify"
          // color="textSecondary"
          // paragraph
          style={{ marginBottom: '35px', color: theme.palette.secondary.dark }}
        >
          {copyWelcome}
        </Typography>

        <Grid container justifyContent="center" spacing={4}>
          {templates ? (
            templates.map((template: ITemplate, index: number) => (
              <Grid item key={index} xs={12} sm={6} md={4}>
                <TemplateItem template={template} />
              </Grid>
            ))
          ) : (
            <></>
          )}
        </Grid>
      </Container>
      <Button
        variant="contained"
        onClick={() =>
          window.open(
            'https://api.whatsapp.com/send?phone=573185725324&text=Hola%21%20Quisiera%20informaci%C3%B3n.',
            '_blank'
          )
        }
        style={{
          backgroundColor: '#1BD741',
          color: 'white',
          top: 'auto',
          bottom: 30,
          left: 'auto',
          right: 65,
          position: 'fixed',
          borderRadius: 20,
          paddingRight: '0.5vh'
        }}
        startIcon={<WAIcon style={{ fontSize: '45px' }} />}
      >
      </Button>
    </>
  )
}

export default TemplateList